var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"outlined":"","dense":"","attach":"","rules":_vm.rules,"label":"Clasificación (Renta)","items":_vm.comprasClasificacionRenta,"item-text":"Valores","item-value":"Codigo"},model:{value:(_vm.clasification),callback:function ($$v) {_vm.clasification=$$v},expression:"clasification"}})
}
var staticRenderFns = []

export { render, staticRenderFns }